(function () {
  var GEN = 'AI generated';
  var MOD = 'AI modified';

  function labelFor(str) {
    if (!str) return null;
    var a = str.toLowerCase();
    // check "modified" first so "ai" substring doesn't misfire
    if (a.indexOf('ai modified') !== -1 || a.indexOf('ai-modified') !== -1) return MOD;
    if (a.indexOf('ai generated') !== -1 || a.indexOf('ai-generated') !== -1) return GEN;
    return null;
  }

  function badge(text, extraClass) {
    var b = document.createElement('span');
    b.className = extraClass ? 'ai-label ' + extraClass : 'ai-label';
    b.textContent = text;
    b.setAttribute('aria-hidden', 'true');
    return b;
  }

  // Images: trigger off alt
  function tagImg(img) {
    if (img.dataset.aiLabelled) return;
    var text = labelFor(img.getAttribute('alt'));
    if (!text) return;

    var parent = img.parentElement;
    if (!parent) return;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

    parent.appendChild(badge(text));
    img.dataset.aiLabelled = '1';
  }

  // Videos: trigger off aria-label (videos have no alt attribute)
  function tagVideo(video) {
    if (video.dataset.aiLabelled) return;
    var text = labelFor(video.getAttribute('aria-label'));
    if (!text) return;

    var parent = video.parentElement;
    if (!parent) return;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

    parent.appendChild(badge(text, 'ai-label--video'));
    video.dataset.aiLabelled = '1';
  }

  function tag(el) {
    if (el.tagName === 'IMG') tagImg(el);
    else if (el.tagName === 'VIDEO') tagVideo(el);
  }

  function scan(root) {
    (root || document).querySelectorAll('img[alt], video[aria-label]').forEach(tag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'IMG' || n.tagName === 'VIDEO') tag(n);
        else if (n.querySelectorAll) scan(n);
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();